import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";
import { getRandomNumber } from "@/lib/random-num.js";
import { config } from "@/utils/config.js";

export function randomGame() {
  eventEmitter.on("randomGame", () => {
    const levelInd = getRandomNumber(3);
    appState.setState("levelInd", levelInd);
    const templateInd = getRandomNumber(5);
    appState.setState("templateInd", templateInd);

    const level = config.levels[levelInd].text;
    appState.setState("level", level);
    const temp = config.levels[levelInd].puzzles[templateInd].name;
    appState.setState("template", temp);

    const matrix = config.levels[levelInd].puzzles[templateInd].matrix;

    appState.setState("matrix", matrix);

    eventEmitter.emit("levelChange");

    eventEmitter.emit("templateChange");
  });
}
